import { InfiniteList } from '@src/design-system/molecules/infinite-list';
import { type ComponentProps, type ElementType, useRef } from 'react';
import type { TInterviewer } from '@shared/types/interviewer';
import { InterviewerInfo } from '@features/participants/pages/detail/components/participant-tabs/appointments-tab/interviewer-info';
import { cn } from '@src/design-system/helpers';
import interviewerApi, {
  type TInterviewerQuery,
} from '@src/features/participants/services/interviewer-api';

export function InterviewersList({
  onClickItem,
  isItemSelected,
  CloseListTrigger,
  props,
}: {
  onClickItem: (item: TInterviewer, isSelected: boolean) => void;
  isItemSelected?: (item: TInterviewer) => boolean;
  CloseListTrigger?: ElementType;
  props?: {
    infiniteListProps?: Partial<
      ComponentProps<typeof InfiniteList<TInterviewer, TInterviewerQuery>>
    >;
    infoItemProps?: Partial<
      ComponentProps<typeof InterviewerInfo<TInterviewer>>
    >;
  };
}) {
  const ref = useRef<HTMLButtonElement>(null);

  return (
    <>
      <InfiniteList
        fetchInfiniteData={interviewerApi.useFetchInfinite}
        animateOnEveryRender
        enableSearch
        searchParamName='interviewer'
        searchParamKey='email'
        props={{ searchInputProps: { placeholder: 'Search by email' } }}
        renderItem={(item) => {
          const isSelected = isItemSelected?.(item);
          return (
            <InterviewerInfo
              id={item.id}
              onClick={() => {
                ref?.current?.click();
                onClickItem(item, !!isSelected);
              }}
              name={item.name}
              item={item}
              avatar={item.avatar}
              jobTitle={item.job_title}
              email={item.email}
              companyName={item.company_name}
              className={cn(isSelected && 'border-active-border bg-primary-50')}
              {...props?.infoItemProps}
            />
          );
        }}
        {...props?.infiniteListProps}
      />
      {CloseListTrigger && (
        <CloseListTrigger
          ref={ref}
          className='hidden'
        />
      )}
    </>
  );
}
